webpackJsonp([2,35],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = new _vue2.default();

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (config) {
	  this.distanceX = 0;
	  this.distanceY = 0;
	  this.startPos = [0, 0];
	  this.currentPos = [0, 0];
	  this.startTime = 0;
	  this.endTime = 0;
	  this.speedX = 0;
	  this.speedY = 0;
	
	  this.state = 'FREE';
	  this.alias = config.alias || '';
	  this.dom = config.dom;
	  this.eventType = config.type || 'swipe';
	  this.callback = config.doing || function () {};
	  this.donecallback = config.done || function () {};
	
	  this.mode = config.mode || 'strict';
	
	  var t = this;
	
	  this.handleTouchStart = function (e) {
	    t.startTime = new Date().getTime();
	    t.state = 'START';
	    var touch = e.targetTouches[0];
	    t.startPos = [touch.pageX, touch.pageY];
	
	    t.callback('touchstart', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.startPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchMove = function (e) {
	    t.state = 'MOVING';
	    var touch = e.targetTouches[0];
	    t.currentPos = [touch.pageX, touch.pageY];
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	    t.callback('touchmove', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.currentPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchEnd = function () {
	    t.state = 'END';
	    t.endTime = new Date().getTime();
	    var time = Math.floor((t.endTime - t.startTime) / 1000);
	
	    if (t.currentPos[0] === 0 || t.currentPos[1] === 0) {
	      t.currentPos = t.startPos;
	    }
	
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	
	    if (time === 0) time = 1;
	    t.speedX = Math.abs(t.distanceX / time);
	    t.speedY = Math.abs(t.distanceY / time);
	
	    if (!t.actions[t.eventType]()) {
	      t.callback('touchend', {
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    } else {
	      if (t.mode === 'unstrict') {
	        t.callback('touchend', {
	          distance: { x: t.distanceX, y: t.distanceY },
	          speed: { x: t.speedX, y: t.speedY },
	          position: t.currentPos,
	          state: t.state,
	          alias: t.alias
	        });
	      }
	
	      t.donecallback({
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    }
	
	    t.state = 'FREE';
	    t.distanceX = 0;
	    t.distanceY = 0;
	    t.startTime = 0;
	    t.endTime = 0;
	    t.speedX = 0;
	    t.speedY = 0;
	    t.startPos = [0, 0];
	    t.currentPos = [0, 0];
	  };
	
	  this.actions = {
	    swipe: function swipe() {
	      return true;
	    },
	    swipeDown: function swipeDown() {
	      if (t.distanceY > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeUp: function swipeUp() {
	      if (t.distanceY < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeLeft: function swipeLeft() {
	      if (t.distanceX < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeRight: function swipeRight() {
	      if (t.distanceX > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeX: function swipeX() {
	      if (Math.abs(t.distanceX) > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeY: function swipeY() {
	      if (Math.abs(t.distanceY) > 60) {
	        return true;
	      }
	      return false;
	    }
	  };
	
	  this.init = function () {
	    this.dom.addEventListener('touchstart', this.handleTouchStart);
	    this.dom.addEventListener('touchmove', this.handleTouchMove);
	    this.dom.addEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.destory = function () {
	    this.dom.removeEventListener('touchstart', this.handleTouchStart);
	    this.dom.removeEventListener('touchmove', this.handleTouchMove);
	    this.dom.removeEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.init();
	};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(6),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'btn',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    block: {
	      type: Boolean,
	      default: false
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    disable: {
	      type: Boolean,
	      default: true
	    },
	    loading: {
	      type: Boolean,
	      default: false
	    },
	    submit: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      if (this.submit !== '') {
	        _eventbus2.default.$emit('btn-submit', this.submit);
	      }
	      if (this.disable && !this.loading) {
	        this.$emit('on-click', '');
	      }
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn",
	    class: [
	      'btn-' + _vm.theme,
	      'btn-' + _vm.size,
	      _vm.block ? 'btn-block' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.icon != '' && !_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont",
	    class: [_vm.icon ? 'icon-' + _vm.icon : '']
	  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont icon-loading loading"
	  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])])
	},staticRenderFns: []}

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	'use strict';
	
	var Format = {
	  type: {
	    required: {
	      reg: /.{1,}/,
	      msg: '此项不能为空'
	    },
	    email: {
	      reg: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
	      msg: '邮箱格式错误'
	    },
	    phone: {
	      reg: /^\d{11}$/,
	      msg: '手机格式错误'
	    },
	    float: {
	      reg: /^\d+(.\d+)?$/,
	      msg: '必须为整数或小数'
	    },
	    int: {
	      reg: /^\d+$/,
	      msg: '必须为整数'
	    }
	  },
	  do: function _do(required, format, value) {
	    var _this = this;
	    var pass = { state: true, msg: '' };
	    try {
	      if (typeof value === 'string') {
	        var value = value.replace(/\s/, '');
	      }
	    } catch (e) {
	      return {
	        state: false,
	        msg: '验证发生错误'
	      };
	    }
	
	    if (required) {
	      if (!_this.type.required.reg.test(value)) {
	        return {
	          state: false,
	          msg: _this.type.required.msg
	        };
	      }
	    }
	
	    if (typeof format === 'string') {
	      var tester = _this.type[format];
	    } else {
	      var tester = format;
	    }
	
	    if (tester == undefined) {
	      return pass;
	    }
	
	    if (tester.reg.test(value)) {
	      return pass;
	    } else {
	      if (value == '') {
	        return pass;
	      }
	      return {
	        state: false,
	        msg: tester.msg
	      };
	    }
	  }
	};
	
	module.exports = Format;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _format = __webpack_require__(8);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'formInput',
	  props: {
	    type: {
	      type: String,
	      default: 'text'
	    },
	    name: {
	      type: String,
	      default: ''
	    },
	    value: {
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default' },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    state: {
	      type: String,
	      default: 'normal' },
	    enable: {
	      type: Boolean,
	      default: true
	    },
	    holder: {
	      type: String,
	      default: ''
	    },
	    required: {
	      type: Boolean,
	      default: false
	    },
	    format: {
	      type: String,
	      default: ''
	    },
	    label: {
	      type: String,
	      default: ''
	    },
	    for: {
	      type: String,
	      default: ''
	    },
	    focus: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    getValue: function getValue() {
	      return this.valueSelf;
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    },
	    verify: function verify() {
	      var check = _format2.default.do(this.required, this.format, this.valueSelf);
	      if (check.state) {
	        this.setState('');
	      } else {
	        this.setState('wrong');
	      }
	      return check;
	    },
	    formVerify: function formVerify(formid) {
	      if (this.for === formid) {
	        _eventbus2.default.$emit('input-verify', {
	          formid: formid,
	          result: this.verify(),
	          data: {
	            name: this.name,
	            value: this.valueSelf
	          }
	        });
	      }
	    },
	    handleClick: function handleClick() {
	      this.$emit('on-click', '');
	    }
	  },
	  created: function created() {
	    _eventbus2.default.$on('form-verify', this.formVerify);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.$off('form-verify', this.formVerify);
	  },
	  mounted: function mounted() {
	    if (this.focus) {
	      this.$refs.input.focus();
	    }
	  },
	
	  watch: {
	    value: function value(newval) {
	      this.valueSelf = newval;
	    },
	    valueSelf: function valueSelf(newval) {
	      this.$emit('input', newval);
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.value,
	      stateSelf: this.state
	    };
	  }
	};

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(9),
	  /* template */
	  __webpack_require__(11),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.label != '') ? _c('div', {
	    staticClass: "form-item",
	    class: [
	      'form-item-' + this.theme
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_c('label', {
	    class: ['label-' + this.size],
	    attrs: {
	      "for": _vm.name
	    }
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ]
	  }, [(_vm.type == 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      'input-' + this.theme
	    ],
	    attrs: {
	      "type": "text",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      'input-' + this.theme
	    ],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])]) : _c('div', {
	    staticClass: "form-item",
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.type == 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      this.theme == 'underline' ? 'input-' + this.theme : ''
	    ],
	    attrs: {
	      "type": "text",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      this.theme == 'underline' ? 'input-' + this.theme : ''
	    ],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'formGroup',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    size: {
	      type: String,
	      default: 'default'
	    }
	  },
	  methods: {
	    btnSubmit: function btnSubmit(formid) {
	      if (formid === this.name) {
	        this.pass = true;
	        _eventbus2.default.$emit('form-verify', formid);
	
	        if (this.pass) {
	          this.$emit('on-submit', this.data);
	        }
	      }
	    },
	    receiveInputData: function receiveInputData(data) {
	      if (data.data.name === '' || data.data.name === undefined) {
	        this.pass = false;
	        return;
	      }
	
	      if (data.formid === this.name) {
	        if (data.result.state) {
	          this.data[data.data.name] = data.data.value;
	        } else {
	          this.pass = false;
	          delete this.data[data.data.name];
	        }
	      }
	    }
	  },
	  created: function created() {
	    _eventbus2.default.$on('btn-submit', this.btnSubmit);
	    _eventbus2.default.$on('input-verify', this.receiveInputData);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.$off('btn-submit', this.btnSubmit);
	    _eventbus2.default.$off('input-verify', this.receiveInputData);
	  },
	  data: function data() {
	    return {
	      data: {},
	      pass: true
	    };
	  }
	};

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(22),
	  /* template */
	  __webpack_require__(38),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form",
	    class: [
	      'form-' + _vm.theme,
	      'form-' + _vm.size
	    ]
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'slide-item',
	  props: {
	    imgUrl: String,
	    height: String,
	    width: String
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: {},
	  ready: function ready() {},
	  attached: function attached() {},
	
	  methods: {
	    handleClick: function handleClick() {}
	  },
	  components: {}
	};

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _touchit = __webpack_require__(3);
	
	var _touchit2 = _interopRequireDefault(_touchit);
	
	var _slideItem = __webpack_require__(52);
	
	var _slideItem2 = _interopRequireDefault(_slideItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'slide',
	  components: {
	    slideItem: _slideItem2.default
	  },
	  item: _slideItem2.default,
	  props: {
	    surface: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    ratio: {
	      type: Number,
	      default: 9 / 16
	    },
	    showStatus: {
	      type: Boolean,
	      default: true
	    },
	    width: {
	      type: String,
	      default: '100%'
	    },
	    auto: {
	      type: Boolean,
	      default: true
	    },
	    timeStep: {
	      type: Number,
	      default: 4000
	    }
	  },
	  mounted: function mounted() {
	    this.itemWidth = this.$refs.slide.clientWidth;
	
	    this.touchit = new _touchit2.default({
	      dom: this.$refs.slide,
	      type: 'swipeX',
	      done: this.goTo,
	      doing: this.sliding
	    });
	
	    if (this.auto) {
	      this.autorun();
	    }
	  },
	
	  computed: {
	    fullWidth: function fullWidth() {
	      return this.itemWidth * this.surface.length;
	    },
	    itemHeight: function itemHeight() {
	      return this.itemWidth * this.ratio;
	    }
	  },
	  methods: {
	    autorun: function autorun() {
	      var _this = this;
	
	      clearInterval(this.interval);
	      this.interval = setInterval(function () {
	        if (_this.currentIndex + 1 < _this.surface.length) {
	          _this.currentIndex += 1;
	        } else {
	          _this.currentIndex = 0;
	        }
	        _this.move(-_this.currentIndex * _this.itemWidth, false);
	        _this.preDistance = _this.distance;
	      }, this.timeStep);
	    },
	    handleClick: function handleClick(item) {
	      this.$emit('on-click', item);
	    },
	    sliding: function sliding(eventType, data) {
	      switch (eventType) {
	        case 'touchmove':
	          {
	            this.move(data.distance.x, true);
	            break;
	          }
	        case 'touchend':
	          {
	            this.fixPosition();
	            break;
	          }
	        default:
	          {
	            break;
	          }
	      }
	    },
	    goTo: function goTo(data) {
	      this.autorun();
	
	      if (data.distance.x > 0 && this.currentIndex > 0) {
	        this.currentIndex -= 1;
	      }
	
	      if (data.distance.x < 0 && this.currentIndex + 1 < this.surface.length) {
	        this.currentIndex += 1;
	      }
	
	      this.move(-this.currentIndex * this.itemWidth, false);
	
	      this.preDistance = this.distance;
	    },
	    move: function move(distance, relative) {
	      if (relative) {
	        this.distance = this.preDistance + distance;
	      } else {
	        this.distance = distance;
	      }
	      this.$refs.slidecontent.style.transform = 'translateX(' + this.distance + 'px)';
	    },
	    fixPosition: function fixPosition() {
	      this.move(-this.currentIndex * this.itemWidth, false);
	      this.preDistance = this.distance;
	    },
	    imgload: function imgload() {
	      this.itemHeight = this.height;
	    }
	  },
	  data: function data() {
	    return {
	      items: [],
	      interval: null,
	      itemWidth: 0,
	      currentIndex: 0,
	      preDistance: 0,
	      distance: 0,
	      touchit: null
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.touchit.destory();
	    clearInterval(this.interval);
	  }
	};

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(47),
	  /* template */
	  __webpack_require__(57),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(48),
	  /* template */
	  __webpack_require__(54),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "slide",
	    staticClass: "slide",
	    style: ({
	      height: _vm.itemHeight + 'px',
	      width: _vm.width
	    })
	  }, [_c('div', {
	    ref: "slidecontent",
	    staticClass: "slide-content animate-hack",
	    style: ({
	      width: _vm.fullWidth + 'px'
	    })
	  }, [_vm._l((_vm.surface), function(item) {
	    return _c('slide-item', {
	      attrs: {
	        "imgUrl": item.imgUrl,
	        "width": (_vm.itemWidth + "px"),
	        "height": (_vm.itemHeight + "px")
	      }
	    })
	  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "slide-btns"
	  }, _vm._l((_vm.surface), function(item, key, index) {
	    return _c('button', {
	      staticClass: "slide-btn",
	      class: [key === _vm.currentIndex ? 'slide-btn-current' : '']
	    })
	  }))])
	},staticRenderFns: []}

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "slide-item",
	    style: ({
	      width: _vm.width,
	      height: _vm.height,
	      'background-image': ("url(" + _vm.imgUrl + ")")
	    }),
	    on: {
	      "click": _vm.handleClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(163),
	  /* template */
	  __webpack_require__(242),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _seller = __webpack_require__(218);
	
	var _seller2 = _interopRequireDefault(_seller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'test1',
	  components: {
	    seller: _seller2.default
	  },
	  created: function created() {},
	
	  methods: {},
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formGroup = __webpack_require__(29);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _slide = __webpack_require__(53);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	var _boInput = __webpack_require__(10);
	
	var _boInput2 = _interopRequireDefault(_boInput);
	
	var _btn = __webpack_require__(4);
	
	var _btn2 = _interopRequireDefault(_btn);
	
	var _toast = __webpack_require__(32);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _menusHorizon = __webpack_require__(50);
	
	var _menusHorizon2 = _interopRequireDefault(_menusHorizon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'login',
	  components: {
	    FormGroup: _formGroup2.default,
	    BoInput: _boInput2.default,
	    Btn: _btn2.default,
	    Toast: _toast2.default,
	    Slide: _slide2.default,
	    MenusHorizon: _menusHorizon2.default
	  },
	  props: {},
	  methods: {},
	  data: function data() {
	    return {
	
	      type: 'warm'
	    };
	  }
	};

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(164),
	  /* template */
	  __webpack_require__(238),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 238:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "layout-top"
	  }, [_c('header', {
	    staticClass: "header header-opacity header-search"
	  }, [_c('div', {
	    staticClass: "header-body"
	  }, [_c('bo-input', {
	    attrs: {
	      "size": "sm",
	      "icon": "search",
	      "holder": "请输入搜索内容"
	    }
	  })], 1)])]), _vm._v(" "), _c('section', {
	    staticClass: "layout-main"
	  }, [_c('slide', {
	    attrs: {
	      "surface": [{
	          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/2.png?870bbc643c89ab370522a8eea9cf4985'
	        },
	        {
	          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/1.png?99a3d4cc476cce3ed4826cd912b12876'
	        },
	        {
	          imgUrl: 'http://mlo.jishi88.com/dist/v1.3.7/3.png?b13d9da72fe03c029ff79e1720a318b7'
	        }
	      ]
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('toast', {
	    ref: "toast",
	    attrs: {
	      "type": _vm.type,
	      "content": _vm.content
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bor-bottom bor-top p2020",
	    staticStyle: {
	      "background": "#fff"
	    }
	  }, [_c('nav', {
	    staticClass: "menu-horizon menu-horizon-circle  "
	  }, [_c('button', {
	    staticClass: "menu-horizon-item"
	  }, [_c('span', {
	    staticClass: "menu-pic",
	    staticStyle: {
	      "background": "#FFB30F"
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-creative"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "menu-title"
	  }, [_vm._v("肉类精选")])]), _vm._v(" "), _c('button', {
	    staticClass: "menu-horizon-item"
	  }, [_c('span', {
	    staticClass: "menu-pic",
	    staticStyle: {
	      "background": "#34ad8f"
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-scan"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "menu-title"
	  }, [_vm._v("粮油米面")])]), _vm._v(" "), _c('button', {
	    staticClass: "menu-horizon-item"
	  }, [_c('span', {
	    staticClass: "menu-pic",
	    staticStyle: {
	      "background": "#3492e6"
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-favor"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "menu-title"
	  }, [_vm._v("果蔬副食")])]), _vm._v(" "), _c('button', {
	    staticClass: "menu-horizon-item"
	  }, [_c('span', {
	    staticClass: "menu-pic",
	    staticStyle: {
	      "background": "#FFB30F"
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-favor"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "menu-title"
	  }, [_vm._v("名茶名酒")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bor-bottom bor-top p0020",
	    staticStyle: {
	      "background": "#fff"
	    }
	  }, [_c('nav', {
	    staticClass: "menu-horizon menu-horizon-circle"
	  }, [_c('button', {
	    staticClass: "menu-horizon-item"
	  }, [_c('span', {
	    staticClass: "menu-pic",
	    staticStyle: {
	      "background": "#FFB30F"
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-creative"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "menu-title"
	  }, [_vm._v("野生特产")])]), _vm._v(" "), _c('button', {
	    staticClass: "menu-horizon-item"
	  }, [_c('span', {
	    staticClass: "menu-pic",
	    staticStyle: {
	      "background": "#3492e6"
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-scan"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "menu-title"
	  }, [_vm._v("水产极品")])]), _vm._v(" "), _c('button', {
	    staticClass: "menu-horizon-item"
	  }, [_c('span', {
	    staticClass: "menu-pic",
	    staticStyle: {
	      "background": "#34ad8f"
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-favor"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "menu-title"
	  }, [_vm._v("滋补保健")])]), _vm._v(" "), _c('button', {
	    staticClass: "menu-horizon-item"
	  }, [_c('span', {
	    staticClass: "menu-pic",
	    staticStyle: {
	      "background": "#34ad8f"
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-favor"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "menu-title"
	  }, [_vm._v("工艺礼品")])])])])
	}]}

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('seller')
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.ef10834b44e210f9073b.js